import { useContext } from "react";

import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";
import { CreateOnPremOrderFromRequestRequest } from "./on-prem-order/CreateOnPremOrderFromRequestRequest";
import { ExportOnPremOrdersForProcessingRequest } from "./on-prem-order/ExportOnPremOrdersForProcessingRequest";
import { ExportOnPremOrdersForProcessingResponse } from "./on-prem-order/ExportOnPremOrdersForProcessingResponse";
import { ExportOnPremOrdersResponse } from "./on-prem-order/ExportOnPremOrdersResponse";
import { GetOnPremOrderDetailsRequest } from "./on-prem-order/GetOnPremOrderDetailsRequest";
import { GetOnPremOrderDetailsResponse } from "./on-prem-order/GetOnPremOrderDetailsResponse";
import { GetOnPremOrderListRequest } from "./on-prem-order/GetOnPremOrderListRequest";
import { GetOnPremOrderListResponse } from "./on-prem-order/GetOnPremOrderListResponse";
import { ExportOnPremOrdersRequest } from "./order/ExportOnPremOrdersRequest";
import { GetOrderAuditListRequest } from "./order/GetOrderAuditListRequest";
import { GetOrderAuditListResponse } from "./order/GetOrderAuditListResponse";
import { UpdateOnPremOrderStatusRequest } from "./order/UpdateOnPremOrderStatusRequest";

export const useOnPremOrdersApi = () => {
    const { httpGet, httpPut, httpPost } = useAuthorizedFetch();

    const appConfigContext = useContext(AppConfigContext);

    const baseUrl = appConfigContext.ordersConfig.apiUrl;

    const onPremOrdersBaseUrl = `${baseUrl}/on-prem-order`;

    const getOnPremOrderList = async (request: GetOnPremOrderListRequest): Promise<GetOnPremOrderListResponse> => {
        return httpGet<GetOnPremOrderListResponse>(`${onPremOrdersBaseUrl}/get-on-prem-order-list`, request);
    };

    const getOnPremOrderDetails = async (
        request: GetOnPremOrderDetailsRequest
    ): Promise<GetOnPremOrderDetailsResponse> => {
        return httpGet<GetOnPremOrderDetailsResponse>(`${onPremOrdersBaseUrl}/details/${request.orderId}`);
    };

    const updateOnPremOrderStatus = async (request: UpdateOnPremOrderStatusRequest): Promise<void> => {
        return httpPut(`${onPremOrdersBaseUrl}/update-on-prem-order-status`, request);
    };

    const exportOnPremOrdersForProcessing = async (
        request: ExportOnPremOrdersForProcessingRequest
    ): Promise<ExportOnPremOrdersForProcessingResponse> => {
        return httpPost(`${onPremOrdersBaseUrl}/export-on-prem-orders-for-processing`, request);
    };

    const exportOnPremOrders = async (request: ExportOnPremOrdersRequest): Promise<ExportOnPremOrdersResponse> => {
        return httpPost(`${onPremOrdersBaseUrl}/export-on-prem-orders`, request);
    };

    const getOnPremOrderAuditList = async (request: GetOrderAuditListRequest): Promise<GetOrderAuditListResponse> => {
        return httpGet(`${onPremOrdersBaseUrl}/${request.orderId}/audit-list`, request);
    };

    const createOnPremOrderFromRequest = async (request: CreateOnPremOrderFromRequestRequest): Promise<void> => {
        return httpPost(`${onPremOrdersBaseUrl}/create-from-order-request`, request);
    };

    return {
        getOnPremOrderList,
        getOnPremOrderDetails,
        updateOnPremOrderStatus,
        exportOnPremOrders,
        exportOnPremOrdersForProcessing,
        getOnPremOrderAuditList,
        createOnPremOrderFromRequest
    };
};
